import React from 'react';
import {
  Divider,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps as ChakraModalProps,
  StyleProps,
} from '@chakra-ui/react';
import { Flex } from '../Flex/Flex';
import { Icon } from '../Icon/Icon';
import { Box } from '../Box/Box';
import { ModalProps } from './Modal.types';

export const Modal = ({
  onClose,
  isOpen,
  bodyProps,
  children,
  extraButton,
  Footer,
  footerProps,
  hasClosedButton = true,
  hasFooterDivider,
  hasHeaderDivider = true,
  headerDropdownMenu,
  headerProps,
  leftIconTitle,
  size = 'md',
  title,
  modalProps,
  overlayProps,
  modalContentContainerProps,
  customElements,
  ...props
}: ModalProps & ChakraModalProps & StyleProps) => {
  const hasCustomHeaderElements =
    Array.isArray(customElements) && customElements.length > 0;

  return (
    <ChakraModal
      onClose={onClose}
      isOpen={isOpen}
      size={{
        base: size === 'fullscreen' || size === 'player' ? size : 'mobile',
        md: size,
      }}
      {...modalProps}
      scrollBehavior="inside"
    >
      <ModalOverlay {...overlayProps} />
      <ModalContent
        p={0}
        containerProps={modalContentContainerProps}
        {...props}
      >
        {title && (
          <ModalHeader
            {...(!hasCustomHeaderElements ? { noOfLines: 1 } : {})}
            {...headerProps}
            ml={
              !hasClosedButton && size === 'fullscreen' ? '0px !important' : ''
            }
          >
            {!hasCustomHeaderElements ? (
              <Flex
                alignItems="center"
                h="full"
                w="full"
                justifyContent="space-between"
              >
                <Flex alignItems="center">
                  {leftIconTitle && (
                    <Icon
                      icon={leftIconTitle}
                      size="sm"
                      wrapProps={{ mr: 2 }}
                    />
                  )}
                  <Box>{title}</Box>
                  {extraButton && extraButton}
                </Flex>
                {headerDropdownMenu && <Box>{headerDropdownMenu}</Box>}
              </Flex>
            ) : (
              <Flex
                w="full"
                justifyContent="space-between"
                alignItems="center"
                h="full"
              >
                <Flex flex={1} justifyContent="flex-start" minW={0}>
                  {customElements?.[0]}
                </Flex>
                <Flex
                  flex={4}
                  justifyContent="center"
                  alignItems="center"
                  minW={0}
                  px={2}
                >
                  <Box textAlign="center" noOfLines={2} w="full">
                    {title}
                  </Box>
                </Flex>
                <Flex flex={1} justifyContent="flex-end" minW={0}>
                  {customElements?.[1]}
                </Flex>
              </Flex>
            )}
          </ModalHeader>
        )}
        {title && hasHeaderDivider && size !== 'player' && (
          <Divider width="full" />
        )}
        {hasClosedButton && <ModalCloseButton />}
        {children && <ModalBody {...bodyProps}>{children}</ModalBody>}
        {hasFooterDivider && <Divider width="full" />}
        {Footer && <ModalFooter {...footerProps}>{Footer}</ModalFooter>}
      </ModalContent>
    </ChakraModal>
  );
};
